import { Box, Collapse, LinearProgress, List, ListItemButton, Typography, useMediaQuery, useTheme, Drawer } from '@mui/material'
import { logo, icons } from '../../constants/images'
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { CardDrawer, HeadDrawer, ListItemButtonDrawer, ListItemDrawer, ListItemIconDrawer, ListItemTextDrawer } from './drawerStyle';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
interface propsTypes {
  drawerOpen: boolean,
  setDrawerOpen: any,
  url: string
}
export default function DrawerCustom(props: propsTypes) {
  const { drawerOpen, setDrawerOpen, url } = props
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const { profile } = useSelector((state: any) => state.profile)
  const permit = profile?.permission || []


  const fullScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const [menu, setMenu] = useState([
    { name: 'สถิติข้อมูล', code: 'Dashboard.Read', icon: <icons.chatDrawer />, path: '/dashboard', subMenu: [], status: false },
    {
      name: 'ตู้เอกสาร', code: 'Documents.Read', icon: <icons.folderDrawer />, path: 'documents', subMenu: [
        { name: 'ตู้เอกสารที่แชร์กับฉัน', code: 'Documents.Shared.Read', path: '/shared-documents' },
        { name: 'ตู้เอกสารของฉัน', code: 'Documents.My.Read', path: '/my-documents' }
      ],
      status: true
    },
    { name: 'รายงาน', code: 'Report.Read', icon: <icons.docDrawer />, path: '/report', subMenu: [], status: false },
    {
      name: 'สถิติการใช้งาน', code: 'Statistics.Read', icon: <icons.chartDrawer />, path: '/statistics', subMenu: [
        { name: 'การใช้งานระบบ', code: 'Statistics.Usage.Read', path: '/statistics-usage' },
        { name: 'การดาวน์โหลด', code: 'Statistics.Download.Read', path: '/statistics-download' },
      ], status: false
    },
    {
      name: 'ตั้งค่า', code: 'Setting.Read', icon: <icons.barDrawer />, path: '/setting', subMenu: [
        { name: 'จัดการหน่วยงาน', code: "Department.Read", path: '/settings-agencies' },
        { name: 'จัดการผู้ใช้งาน', code: 'Employees.Read', path: '/settings-users' },
        { name: 'จัดการบทบาท', code: 'Role.Read', path: '/settings-permissions' },
        { name: 'จัดการตำแหน่ง', code: 'Position.Read', path: '/settings-position' },
        { name: 'ปรับแต่ง', code: 'Customize.Read', path: '/settings-customize' },
      ], status: false
    },
  ])


  return (
    <>
      {!fullScreen ? <CardDrawer className={drawerOpen ? 'active' : ''} sx={{ display: { lg: 'block', xs: 'none' } }}>
        <HeadDrawer>
          <img src={`${url}/app-logo`} alt='logo_menu' width='56px' height='56px' />
        </HeadDrawer>
        <List>
          {menu.map((x: any, index: number) => {
            return (
              <>
                {permit.find((role: any) => x?.code === role?.code)?.permit &&
                  <ListItemDrawer key={index} disablePadding>
                    {x.subMenu?.length < 1 ?
                      <ListItemButtonDrawer className={`${drawerOpen ? 'active' : ''} ${location.pathname === x.path ? 'active-toggle' : ''}`}
                        onClick={() => {
                          if (drawerOpen) {
                            navigate(x?.path)
                            setDrawerOpen(!drawerOpen)
                          } else {
                            navigate(x?.path)
                          }
                        }}>
                        <ListItemIconDrawer>
                          {x.icon}
                        </ListItemIconDrawer>
                        <ListItemTextDrawer primary={x.name} />
                      </ListItemButtonDrawer> :
                      <>
                        <ListItemButtonDrawer className={`${drawerOpen ? 'active' : ''} ${location.pathname.includes(x.path) ? 'active-toggle' : ''}`}
                          onClick={() => {
                            if (drawerOpen) {
                              const toggle1 = menu.map((a, i) => {
                                a.status = index === i ? true : a.status
                                return a
                              })
                              setMenu(toggle1)
                              setDrawerOpen(!drawerOpen)
                            } else {
                              const toggle = menu.map((a, i) => {
                                a.status = index === i ? !x?.status : a.status
                                return a
                              })
                              setMenu(toggle)
                            }

                          }}>
                          <ListItemIconDrawer>
                            {x.icon}
                          </ListItemIconDrawer>
                          <ListItemTextDrawer primary={x.name} />
                          {!drawerOpen && (x.status ? <ExpandLess /> : <ExpandMore />)}
                        </ListItemButtonDrawer>
                        <Collapse in={!drawerOpen ? x.status : false}>
                          <List component="div" disablePadding sx={{
                            '.toggle': {
                              borderLeft: '4px solid #026735',
                              paddingLeft: "44px",
                              background: '#EFFFF7',
                            }
                          }}>
                            {x.subMenu.map((y: any, i: number) => {
                              return (
                                <>
                                  {permit.find((role: any) => y?.code === role?.code)?.permit &&
                                    <ListItemButton key={i} className={`${location.pathname.includes(y.path.substr(1)) ? 'toggle' : ''}`} onClick={() => navigate(y?.path)} sx={{ pl: '48px' }}>
                                      <ListItemTextDrawer primary={y.name} />
                                    </ListItemButton>
                                  }
                                </>
                              )
                            })}
                          </List>
                        </Collapse>
                      </>}
                  </ListItemDrawer>}
              </>
            )
          }
          )}
        </List>

        <Box sx={{ display: !drawerOpen ? 'block' : 'none', borderTop: '1px solid rgba(16, 24, 40, 0.04)', padding: '16px 5px 0px' }}>
          <div style={{ padding: '16px', background: '#F3FFF6' }}>
            <Typography sx={{ fontSize: "14px", fontWeight: '500' }}>พื้นที่เก็บข้อมูล</Typography>
            <LinearProgress sx={{
              margin: "16px 0px", height: '10px', background: '#E5E5E7', borderRadius: "10px",
              '.MuiLinearProgress-bar': {
                background: "#026735",
                borderRadius: "10px"
              }
            }} variant="determinate" value={(profile?.uploadUsed / profile?.uploadMax) * 100} />
            <Typography sx={{ fontSize: "14px", fontWeight: '300' }}>ใช้ไป {profile?.uploadUsed?.toFixed(4)} GB จาก {profile?.uploadMax} GB</Typography>
          </div>
        </Box>
      </CardDrawer > :
        <Drawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        >

          <CardDrawer sx={{ width: '300px', maxWidth: '300px', background: '#fff' }}>
            <HeadDrawer>
              <img src={logo.logoMenu} alt='logo_menu' width='45px' height='45px' />
            </HeadDrawer>
            <List>
              {menu.map((x: any, index: number) => {
                return (
                  <ListItemDrawer key={index} disablePadding>
                    {x.subMenu?.length < 1 ?
                      <ListItemButtonDrawer className={`${!drawerOpen ? 'active' : ''} ${location.pathname === x.path ? 'active-toggle' : ''}`}
                        onClick={() => {
                          if (drawerOpen) {
                            navigate(x?.path)
                            setDrawerOpen(!drawerOpen)
                          } else {
                            navigate(x?.path)
                          }
                        }}>
                        <ListItemIconDrawer>
                          {x.icon}
                        </ListItemIconDrawer>
                        <ListItemTextDrawer primary={x.name} />
                      </ListItemButtonDrawer> :
                      <>
                        <ListItemButtonDrawer className={`${!drawerOpen ? 'active' : ''} ${location.pathname.includes(x.path) ? 'active-toggle' : ''}`}
                          onClick={() => {

                            const toggle = menu.map((a, i) => {
                              a.status = index === i ? !x?.status : a.status
                              return a
                            })
                            setMenu(toggle)

                          }}>
                          <ListItemIconDrawer>
                            {x.icon}
                          </ListItemIconDrawer>
                          <ListItemTextDrawer primary={x.name} />
                          {drawerOpen && (x.status ? <ExpandLess /> : <ExpandMore />)}
                        </ListItemButtonDrawer>
                        <Collapse in={drawerOpen ? x.status : false}>
                          <List component="div" disablePadding sx={{
                            '.toggle': {
                              borderLeft: '4px solid #026735',
                              paddingLeft: "44px",
                              background: '#EFFFF7',
                            }
                          }}>
                            {x.subMenu.map((y: any, i: number) => {
                              return (
                                <ListItemButton key={i} className={`${location.pathname.includes(y.path.substr(1)) ? 'toggle' : ''}`}
                                  onClick={() => {
                                    setDrawerOpen(!drawerOpen)
                                    navigate(y?.path)
                                  }} sx={{ pl: '48px' }}>
                                  <ListItemTextDrawer primary={y.name} />
                                </ListItemButton>
                              )
                            })}
                          </List>
                        </Collapse>
                      </>}
                  </ListItemDrawer>
                )
              }
              )}
            </List>
            <Box sx={{ display: drawerOpen ? 'block' : 'none', borderTop: '1px solid rgba(16, 24, 40, 0.04)', padding: '16px 5px 0px' }}>
              <div style={{ padding: '16px', background: '#F3FFF6' }}>
                <Typography sx={{ fontSize: "14px", fontWeight: '500' }}>พื้นที่เก็บข้อมูล</Typography>
                <LinearProgress sx={{
                  margin: "16px 0px", height: '10px', background: '#E5E5E7', borderRadius: "10px",
                  '.MuiLinearProgress-bar': {
                    background: "#026735",
                    borderRadius: "10px"
                  }
                }} variant="determinate" value={(profile?.uploadUsed / profile?.uploadMax) * 100} />
                <Typography sx={{ fontSize: "14px", fontWeight: '300' }}>ใช้ไป {profile?.uploadUsed?.toFixed(4)} GB จาก {profile?.uploadMax} GB</Typography>
              </div>
            </Box>
          </CardDrawer >
        </Drawer>

      }
    </>
  )
}
